import scheduleNextPaint from '@/helpers/scheduleNextPaint';
import perfDebug from '@/helpers/perfDebug';

/**
 * Обходит array-like (массив, NodeList) чанками, между чанками — scheduleFrame (по умолчанию rAF).
 * Снижает длину задач на main thread (TBT).
 *
 * @param {ArrayLike<*>} arrayLike
 * @param {{ chunkSize?: number, scheduleFrame?: (cb: () => void) => void, perfLabel?: string }} options
 * @param {(item: *, index: number) => void} iteratee
 * @return {Promise<void>}
 */
export default function forEachInRafChunks(arrayLike, options, iteratee) {
  const opts = options || {};
  const chunkSize = opts.chunkSize > 0 ? opts.chunkSize : 1;
  const scheduleFrame = opts.scheduleFrame || scheduleNextPaint;
  const length = arrayLike == null ? 0 : arrayLike.length;
  const perfLabel = opts.perfLabel;
  const perf = perfDebug.isEnabled() && perfLabel;

  return new Promise(function(resolve) {
    if (!length) {
      resolve();

      return;
    }

    let index = 0;
    let chunkIndex = 0;

    function runChunk() {
      const chunkStart = index;
      const end = Math.min(index + chunkSize, length);
      const t0 = perf ? perfDebug.now() : 0;

      for (; index < end; index++) {
        iteratee(arrayLike[index], index);
      }

      if (perf) {
        const t1 = perfDebug.now();
        const ms = t1 - t0;
        const detail = {
          chunkIndex,
          items: end - chunkStart,
          fromIndex: chunkStart,
          toIndex: end - 1,
        };
        perfDebug.log(`${perfLabel}:chunk`, detail, ms);
        perfDebug.ensureSummary().chunks.push({ label: perfLabel, ...detail, ms });
        perfDebug.measureRange(`${perfLabel}:chunk:${chunkIndex}`, t0, t1);
      }
      chunkIndex += 1;

      if (index < length) {
        scheduleFrame(runChunk);
      } else {
        resolve();
      }
    }

    runChunk();
  });
}
